<style lang="scss" scoped>
  .RoomTitle {

    .column {
      padding-top: 0;
      padding-bottom: 0;
    }

    &__title {
      height: 4rem;
      font-size: 30px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.9px;
      text-align: left;
      color: #202020;
/*      margin-left: 1rem;*/
    }

    &__edit-input {
      margin-left: 1rem;
    
      @media only screen and (max-width: 1000px) {
        margin-left: -20px;
      }
    }

    &__edit-icon {
      color: #ccc;
      padding-top: 1rem;
    }

    &__separator {
      width: 100%;
      border: solid 1px #f0f0f0;
    }
    &__cursor-pointer {
      cursor: pointer;
      @media only screen and (max-width: 770px) {
        float: right;
        margin-top: -40px;
        margin-right: 15px;
      }
    }
  }
</style>

<template lang="pug">
  .RoomTitle
    .columns(v-if="shouldEdit")
      .column.is-1
      .column.is-three-quarters
        input.input.is-fullwidth.RoomTitle__edit-input(type="text", v-model.trim="editedTitle" @keyup.enter="toggleEdit" @keyup.esc="switchToUneditMode")
      .column
        span.RoomTitle__edit-icon.fa.fa-save.RoomTitle__cursor-pointer(@click="toggleEdit")
    .columns(v-else)
      .column.is-1
      .column.is-three-quarters
        span.RoomTitle__title {{roomTitle}} &nbsp;
      .column
        span.RoomTitle__edit-icon.fa.fa-pencil.RoomTitle__cursor-pointer(@click="toggleEdit")
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'RoomTitle',

    props: {
      title: String,
    },

    data() {
      return {
        shouldEdit: false,
        editedTitle: String(this.title),
        roomTitle: String(this.title),
      };
    },
    methods: {
      ...mapGetters('Firebase', ['getRoomById']),
      ...mapActions('Firebase', ['updateRoomTitle']),
      async toggleEdit() {
        this.shouldEdit = !this.shouldEdit;

        if (this.editedTitle !== this.roomTitle) {
          const room = this.getRoomById()(this.$route.params.id);
          const updateObj = {
            ...room,
            title: this.editedTitle,
          };

          // Validate the input
          const roomNameLength = this.editedTitle.length;
          if (roomNameLength >= 1 && roomNameLength <= 20) {
            // Dispatch an action to create a new room.
            const isUpdated = await this.updateRoomTitle(updateObj);
            if (isUpdated) {
              this.roomTitle = this.editedTitle;
            } else {
              this.shouldEdit = !this.shouldEdit;
            }
          } else {
            this.shouldEdit = !this.shouldEdit;
            // eslint-disable-next-line no-console
            console.log('Invalid input.');
          }
        }
      },
      switchToUneditMode() {
        this.editedTitle = this.roomTitle;
        this.shouldEdit = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/Room/components/RoomTitle.vue